import { token } from '@atlaskit/tokens';

export const REMIX_PLACEHOLDER_WIDGET_KEY = 'ai-suggestions-remix-placeholder';

/** Marks the widget host; the placeholder inside is portalled, so only the host is always present. */
export const REMIX_PLACEHOLDER_CONTAINER_TESTID = 'ai-suggestions-remix-placeholder-container';

/** Block-level, non-editable host that the RemixPlaceholder portal renders into. */
export function createRemixPlaceholderContainer(): HTMLElement {
	const element = document.createElement('div');
	element.contentEditable = 'false';
	element.setAttribute('data-testid', REMIX_PLACEHOLDER_CONTAINER_TESTID);
	// Set once here, never mutated: the scroll margin gives clearance when we scroll the host.
	element.setAttribute(
		'style',
		`display: block; width: 100%; pointer-events: none; scroll-margin-top: ${token('space.400')};`,
	);
	return element;
}
